import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonFeaturesLayout } from "../cta-button-features-layout";
import { CTAButtonFeaturesListLayoutContext } from "./features-list-layout.model";

@Component({
    selector: "dodo-features-list-layout",
    templateUrl: "./features-list-layout.component.html",
    styleUrls: ["./features-list-layout.component.scss"],
    standalone: false
})
export class FeaturesListLayoutComponent
	extends CTAButtonFeaturesLayout<CTAButtonFeaturesListLayoutContext>
	implements OnInit {
	@Input() title: string;
	@Input() subtitle: string;
	@Input() factsheet: {
		text: string;
		url: string;
	};
	@Input() moreInfoLink: {
		text: string;
		url: string;
	};
	@Input() features: string[];

	// set layoutContext(ctx: CTAButtonFeaturesListLayoutContext) {
	// 	this.title = this.title || ctx.title;
	// 	this.subtitle = this.subtitle || ctx.subtitle;
	// 	this.factsheet = this.factsheet || ctx.factsSheet;
	// 	this.moreInfoLink = this.moreInfoLink || ctx.moreInfoLink;
	// 	this.features = this.features || ctx.features;
	// }

	set context(ctx: CTAButtonFeaturesListLayoutContext) {
		this.title = this.title || ctx.title;
		this.subtitle = this.subtitle || ctx.subtitle;
		this.factsheet = this.factsheet || ctx.factsSheet;
		this.moreInfoLink = this.moreInfoLink || ctx.moreInfoLink;
		this.features = this.features || ctx.features;
	}

	constructor() {
		super();
	}

	ngOnInit() {}

	public _goToLink(url: string): void {
		window.open(url, "_blank");
	}
}
